import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastFacade } from '@symphony-solo/domain/toast/src';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ErrorCode } from '@symphony-solo/shared/error-handling/src';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { PurchaseHistoryService } from '../services';
import { getPurchaseHistoryAction, getPurchaseHistoryErrorAction, getPurchaseHistorySuccessAction } from './purchase-history.actions';

@Injectable()
export class PurchaseHistoryEffects {
  constructor(
    private action$: Actions,
    private purchaseHistoryService: PurchaseHistoryService,
    private toastFacade: ToastFacade,
    private navController: NavController
  ) {}

  protected getPurchaseHistory$ = createEffect(() =>
    this.action$.pipe(
      ofType(getPurchaseHistoryAction),
      switchMap(() => {
        return this.purchaseHistoryService.getPurchaseHistory().pipe(
          map((purchaseHistory) => {
            return getPurchaseHistorySuccessAction({ purchaseHistoryItems: purchaseHistory });
          }),
          catchError(() => {
            const errorMessage = 'Could not get purchase history';
            this.toastFacade.showToastErrorMessage(errorMessage);

            const failures = new AppStateFailureBuilder()
              .setFailureType(FailureType.API)
              .addFailure(new AppStateFailureItemWithErrorCode(errorMessage, ErrorCode.CouldNotGetPurchaseHistory))
              .build();

            return of(getPurchaseHistoryErrorAction({ failures }));
          })
        );
      })
    )
  );

  protected getPurchaseHistoryError$ = createEffect(
    () => {
      return this.action$.pipe(
        ofType(getPurchaseHistoryErrorAction),
        tap(() => {
          this.navController.pop();
        })
      );
    },
    { dispatch: false }
  );
}
